import React from "react";
import { Box, Theme, useTheme } from "@material-ui/core";
import { AutocompleteArrayInput, AutocompleteArrayInputProps, Button } from "react-admin";
import { useForm } from "react-final-form";

const AutocompleteArrayInputWithSelectAll = (props: AutocompleteArrayInputProps) => {
  const form = useForm(); 
  const theme = useTheme<Theme>();

  const handleSelectAll = () => {
    const allIds = (props.choices as { id: string | number }[])?.map((choice) => choice.id);
    form.change(props.source!, allIds);
  };

  const handleRemoveSelection = () => {
    form.change(props.source!, []); 
  };

  const selectedValues = form.getState().values[props.source!];
  const hasSelection = Array.isArray(selectedValues) && selectedValues.length > 0;

  return (
    <Box sx={{ position: "relative", minWidth: "100%" }}>
      <Box
        sx={{
          position: "absolute",
          top: "-24px",
          right: "50%",
          display: "flex",
        }}
      >
        <Button size="small" label="Select all" onClick={handleSelectAll} />
        {hasSelection && (
          <Button size="small" color="default" style={{ color: theme.palette.error.main }} label="Remove selection" onClick={handleRemoveSelection} />
        )}
      </Box>
      <AutocompleteArrayInput {...props} /> 
    </Box>
  );
};

export default AutocompleteArrayInputWithSelectAll;
